// src/pages/Index.tsx
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import  HeroSection  from "@/components/landing/HeroSection";
import { AudienceSection } from "@/components/landing/AudienceSection";
import { SkillsSection } from "@/components/landing/SkillsSection";
import { BenefitsSection } from "@/components/landing/BenefitsSection";
import { TestimonialSection } from "@/components/landing/TestimonialSection";
import { Footer } from "@/components/landing/Footer";
import  EnrollmentModal  from "@/components/enrollment/EnrollmentModal";
import { FloatingWhatsAppButton } from "@/components/FloatingWhatsappButton";

export default function Index() {
  const [enrollModalOpen, setEnrollModalOpen] = useState(false);

  const handleOpenModal = () => {
    setEnrollModalOpen(true);
  };

  const handleCloseModal = () => {
    setEnrollModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Janet Marketing Academy - Digital Marketing Training Kenya</title>
        <meta
          name="description"
          content="Learn practical social media marketing and online selling skills. 4-week intensive training starting Jan 13, 2026. Enroll now for KSh 15,000."
        />
        <meta
          name="keywords"
          content="digital marketing, social media marketing, online selling, marketing training Kenya, Janet Marketing Academy"
        />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Janet Marketing Academy - Digital Marketing Training" />
        <meta property="og:description" content="Master social media marketing and online selling in 4 weeks. Practical training with certificate." />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Janet Marketing Academy - Digital Marketing Training" />
        <meta name="twitter:description" content="Master social media marketing and online selling in 4 weeks. Practical training with certificate." />
      </Helmet>

      {/* Hero Section with Countdown */}
      <HeroSection onEnrollClick={handleOpenModal} />

      <FloatingWhatsAppButton/>
      
      {/* Who Should Attend */}
      <AudienceSection />
      
      {/* Skills You'll Learn */}
      <SkillsSection />
      
      {/* Benefits & Features */}
      <BenefitsSection />
      
      {/* Success Stories */}
      <TestimonialSection />
      
      {/* Footer */}
      <Footer />

      {/* Enrollment Modal */}
      <EnrollmentModal
        open={enrollModalOpen}
        onOpenChange={handleCloseModal}
      />
    </>
  );
}